import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, DatePicker, Select, TextInput } from 'components/Form'
import { createApiRecord, updateApiRecord } from 'services/ExtraChargeService'
import { useDispatch, useSelector } from 'react-redux'
import { getRecord } from './store/dataSlice'
import reducer from './store'
import { injectReducer } from 'store'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Success } from 'utils/alerts'
import { yesNoOptions } from 'utils/options'
import {
    getTransportProviderData,
    getTransportProviderServiceData,
} from 'store/data/dataSlice'
import dayjs from 'dayjs'
injectReducer('extraCharges', reducer)

const validationSchema = Yup.object().shape({
    company: Yup.number().required('Please select company'),
    client: Yup.number().nullable(),
    transport_provider: Yup.number().required(
        'Please select transport provider',
    ),
    service: Yup.number().nullable(),
    fee_code: Yup.string().required('Fee Code Required'),
    fee_description: Yup.string().required('Fee Description Required'),
    buy_fee_applies_to: Yup.string().required('Buy Fee applies to Required'),
    sell_fee_applies_to: Yup.string().required('Sell Fee Applies to Required'),
    charge_value: Yup.number().required('Charge Value is required'),
    type: Yup.string().nullable(),
    start_date: Yup.date().required('Start date is required'),
    end_date: Yup.date().required('End date required'),
    is_fuel_levy_exempt: Yup.boolean().required('Fuel leavy exempt required'),
})

const Create = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {
        companyData,
        clientCompanyData,
        transportProviderData,
        transportProviderServiceData,
    } = useSelector((state) => state.listData)
    const { view, record, loading } = useSelector(
        (state) => state.extraCharges.data,
    )

    useEffect(() => {
        if (id) {
            fetchData(id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    const fetchData = (id) => dispatch(getRecord(id))

    const handleDiscard = () => navigate('/master-data/extra-charges')

    const handleSubmit = (values, setSubmitting) => {
        values.start_date = dayjs(values.start_date).format('YYYY-MM-DD')
        values.end_date = dayjs(values.end_date).format('YYYY-MM-DD')
        setSubmitting(true)
        if (id) {
            updateApiRecord(id, values)
                .then(() => {
                    Success('Updated Successfully!')
                    handleDiscard()
                    // dispatch(getCompanyData())
                    setSubmitting(false)
                })
                .catch((error) => {
                    setSubmitting(false)
                    return error
                })
        } else {
            createApiRecord(values)
                .then(() => {
                    Success('Created Successfully!')
                    handleDiscard()
                    // dispatch(getCompanyData())
                    setSubmitting(false)
                })
                .catch((error) => {
                    setSubmitting(false)
                    return error
                })
        }
    }

    if (loading) {
        return null
    }

    return (
        <>
            <div className="flex flex-col gap-1 mb-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">
                    Extra Charges
                </h2>
            </div>
            <div className="flex flex-col items-center">
                <div className="w-full bg-white border rounded-lg border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    <div className="px-5 py-3 border-b border-stroke dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">
                            {id
                                ? 'Update Extra Charge'
                                : 'Add New Extra Charge'}
                        </h3>
                    </div>
                    <div className="flex flex-col gap-3 p-6">
                        <Formik
                            initialValues={id ? record : view}
                            validationSchema={validationSchema}
                            onSubmit={(values, { setSubmitting }) => {
                                handleSubmit(values, setSubmitting)
                            }}
                        >
                            {({ values, touched, errors, isSubmitting }) => (
                                <Form>
                                    <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-6">
                                        <Field name="company">
                                            {({ field, form }) => (
                                                <Select
                                                    options={companyData}
                                                    label="Company"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="company"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.company &&
                                                        touched.company
                                                    }
                                                    message={errors.company}
                                                    value={values?.company}
                                                    onChange={(e) => {
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                        form.setFieldValue(
                                                            'client',
                                                            '',
                                                        )
                                                        form.setFieldValue(
                                                            'transport_provider',
                                                            '',
                                                        )
                                                        form.setFieldValue(
                                                            'service',
                                                            '',
                                                        )
                                                        dispatch(
                                                            getTransportProviderData(
                                                                {
                                                                    company:
                                                                        e.target
                                                                            .value,
                                                                },
                                                            ),
                                                        )
                                                        dispatch(
                                                            getTransportProviderServiceData(
                                                                {
                                                                    company:
                                                                        e.target
                                                                            .value,
                                                                },
                                                            ),
                                                        )
                                                    }}
                                                />
                                            )}
                                        </Field>
                                        <Field name="client">
                                            {({ field, form }) => (
                                                <Select
                                                    options={clientCompanyData?.filter(
                                                        (item) =>
                                                            item?.client &&
                                                            item?.company?.id.toString() ===
                                                                values?.company,
                                                    )}
                                                    label="Client Company"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="client"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.client &&
                                                        touched.client
                                                    }
                                                    message={errors.client}
                                                    value={values?.client}
                                                    disabled={!values?.company}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="transport_provider">
                                            {({ field, form }) => (
                                                <Select
                                                    options={transportProviderData?.filter(
                                                        (item) =>
                                                            item.type ===
                                                            'Aggregator',
                                                    )}
                                                    label="Transport Provider"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="transport_provider"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.transport_provider &&
                                                        touched.transport_provider
                                                    }
                                                    message={
                                                        errors.transport_provider
                                                    }
                                                    value={
                                                        values?.transport_provider
                                                    }
                                                    disabled={!values?.company}
                                                    onChange={(e) => {
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }}
                                                />
                                            )}
                                        </Field>
                                        <Field name="service">
                                            {({ field, form }) => (
                                                <Select
                                                    options={
                                                        transportProviderServiceData
                                                    }
                                                    label="Transport Provider Service"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="service"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.service &&
                                                        touched.service
                                                    }
                                                    message={errors.service}
                                                    value={values?.service}
                                                    disabled={!values?.company}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="fee_code">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    className="md:col-span-2"
                                                    label="Fee Code"
                                                    name="fee_code"
                                                    error={
                                                        errors.fee_code &&
                                                        touched.fee_code
                                                    }
                                                    message={errors.fee_code}
                                                    value={values?.fee_code}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="fee_description">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    className="md:col-span-2"
                                                    label="Fee Description"
                                                    name="fee_description"
                                                    error={
                                                        errors.fee_description &&
                                                        touched.fee_description
                                                    }
                                                    message={
                                                        errors.fee_description
                                                    }
                                                    value={
                                                        values?.fee_description
                                                    }
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="buy_fee_applies_to">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    className="md:col-span-2"
                                                    label="Buy Fee Applies To"
                                                    name="buy_fee_applies_to"
                                                    error={
                                                        errors.buy_fee_applies_to &&
                                                        touched.buy_fee_applies_to
                                                    }
                                                    message={
                                                        errors.buy_fee_applies_to
                                                    }
                                                    value={
                                                        values?.buy_fee_applies_to
                                                    }
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="sell_fee_applies_to">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    className="md:col-span-2"
                                                    label="Sell Fee Applies To"
                                                    name="sell_fee_applies_to"
                                                    error={
                                                        errors.sell_fee_applies_to &&
                                                        touched.sell_fee_applies_to
                                                    }
                                                    message={
                                                        errors.sell_fee_applies_to
                                                    }
                                                    value={
                                                        values?.sell_fee_applies_to
                                                    }
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="charge_value">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    className="md:col-span-2"
                                                    label="Charge Value"
                                                    name="charge_value"
                                                    error={
                                                        errors.charge_value &&
                                                        touched.charge_value
                                                    }
                                                    message={
                                                        errors.charge_value
                                                    }
                                                    value={values?.charge_value}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="type">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    className="md:col-span-2"
                                                    label="Type"
                                                    name="type"
                                                    error={
                                                        errors.type &&
                                                        touched.type
                                                    }
                                                    message={errors.type}
                                                    value={values?.type}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="start_date">
                                            {({ field, form }) => (
                                                <DatePicker
                                                    className="md:col-span-2"
                                                    label="Start Date"
                                                    name="start_date"
                                                    error={
                                                        errors.start_date &&
                                                        touched.start_date
                                                    }
                                                    message={errors.start_date}
                                                    value={
                                                        values?.start_date
                                                            ? dayjs(
                                                                  values?.start_date,
                                                              ).format(
                                                                  'YYYY-MM-DD',
                                                              )
                                                            : ''
                                                    }
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="end_date">
                                            {({ field, form }) => (
                                                <DatePicker
                                                    className="md:col-span-2"
                                                    label="End Date"
                                                    name="end_date"
                                                    error={
                                                        errors.end_date &&
                                                        touched.end_date
                                                    }
                                                    message={errors.end_date}
                                                    value={
                                                        values?.end_date
                                                            ? dayjs(
                                                                  values?.end_date,
                                                              ).format(
                                                                  'YYYY-MM-DD',
                                                              )
                                                            : ''
                                                    }
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="is_fuel_levy_exempt">
                                            {({ field, form }) => (
                                                <Select
                                                    options={yesNoOptions}
                                                    label="Fuel Levy Exempt"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="is_fuel_levy_exempt"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.is_fuel_levy_exempt &&
                                                        touched.is_fuel_levy_exempt
                                                    }
                                                    message={
                                                        errors.is_fuel_levy_exempt
                                                    }
                                                    value={
                                                        values?.is_fuel_levy_exempt
                                                    }
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                    </div>
                                    <div className="flex items-center justify-end gap-4 mt-3">
                                        <Button
                                            className="h-10 w-18 text-primary border border-primary dark:text-secondary dark:border-secondary"
                                            onClick={handleDiscard}
                                        >
                                            Discard
                                        </Button>
                                        <Button
                                            type="submit"
                                            className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                            disabled={isSubmitting}
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Create
